var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17746 14.115C7.03496 14.115 6.89246 14.0625 6.77996 13.95L2.22746 9.3975C2.00996 9.18 2.00996 8.82 2.22746 8.6025L6.77996 4.05C6.99746 3.8325 7.35746 3.8325 7.57496 4.05C7.79246 4.2675 7.79246 4.6275 7.57496 4.845L3.41996 9L7.57496 13.155C7.79246 13.3725 7.79246 13.7325 7.57496 13.95C7.46996 14.0625 7.31996 14.115 7.17746 14.115Z",
    fill: "#C4AB73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3749 9.5625H2.75244C2.44494 9.5625 2.18994 9.3075 2.18994 9C2.18994 8.6925 2.44494 8.4375 2.75244 8.4375H15.3749C15.6824 8.4375 15.9374 8.6925 15.9374 9C15.9374 9.3075 15.6824 9.5625 15.3749 9.5625Z",
    fill: "#C4AB73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a3a9857bccf8e409cd92d168230268ba.svg";
export { ForwardRef as ReactComponent };